export default "__VITE_ASSET__BO0he1Qk__"